import { render, staticRenderFns } from "./EditInvoiceModal.vue?vue&type=template&id=5f8aba87"
import script from "./EditInvoiceModal.vue?vue&type=script&lang=js"
export * from "./EditInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./EditInvoiceModal.vue?vue&type=style&index=0&id=5f8aba87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports